module.exports = __webpack_public_path__ + "img/night-unicorn.d7d52f5e.svg";